export const telezhki = {
    telezhka__tm__900: {
        name: "Тележка ТМ, мм",
        title: "Тележка ТМ",
        price: 0,
        active: false,
        type: "500x900, 2 полки",
        width: 500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    telezhka__tm__900_3: {
        name: "Тележка ТМ, мм",
        title: "Тележка ТМ",
        price: 0,
        active: false,
        type: "500x900, 3 полки",
        width: 500,
        depth: 900,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    telezhka__ti: {
        name: "Тележка ТИ, мм",
        title: "Тележка ТИ",
        price: 0,
        active: false,
        type: "850x480",
        width: 850,
        depth: 480,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    telezhka__tmu: {
        name: "Тележка ТМУ, мм",
        title: "Тележка ТМУ",
        price: 0,
        active: false,
        type: "620x1200",
        width: 620,
        depth: 1200,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
    telezhka__al_kp: {
        name: "Тележка АЛ-КП, мм",
        title: "Тележка АЛ-КП",
        price: 0,
        active: false,
        type: "500x1300",
        width: 500,
        depth: 1300,
        piece: 0,
        price_esd: 0,
        position: "table",
    },
};
export const dop_polka__telezhka__1 = {
    dop_polka__telezhka__1: {
        name: "Дополнительная полка",
        title: "Дополнительная полка",
        price: 0,
        price_esd: 0,
        active: false,
        type: "—",
        piece: 0,
        position: null,
    },
};
export const dop_polka__telezhka__2 = {
    dop_polka__telezhka__2: {
        name: "Дополнительная полка",
        title: "Дополнительная полка",
        price: 0,
        price_esd: 0,
        active: false,
        type: "—",
        piece: 0,
        position: null,
    },
};
